export function isNfeSituacao(situacao: string | undefined, expected: string): boolean {
  if (!situacao) return false;
  const normalized = situacao.replace(/\s+/g, '_').toUpperCase();
  const expectedNormalized = expected.replace(/\s+/g, '_').toUpperCase();
  return normalized === expectedNormalized;
}

export function isNfeBloqueante(situacao: string | undefined): boolean {
  return isNfeSituacao(situacao, 'AUTORIZADA') || isNfeSituacao(situacao, 'EM_PROCESSO');
}
